import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  makeStyles,
  AppBar,
  Toolbar,
  IconButton,
  MenuItem,
} from '@material-ui/core';
import { AccountCircle, Home as HomeIcon } from '@material-ui/icons';

import Menu from '~/components/Menu';
import { signout } from '../../../store/modules/auth/actions';
import logo from '../../../images/Logo.png';
import { Logo } from '../global/styles';

const NavBar = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  const handleHome = () => history.push('/home');
  const handleProfile = () => history.push('/profile');
  const handleTrainingRoutinesHistory = () => {
    history.push(`/users/${user.id}/training-routines`);
  };
  const handleSignout = () => dispatch(signout());

  const [anchorEl, setAnchorEl] = React.useState(null);
  const isOpen = !!anchorEl;
  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
  }));
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" color="inherit">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            style={{ color: '#f76d31' }}
            onClick={handleHome}
          >
            <HomeIcon />
          </IconButton>
          <Logo src={logo} alt="Logo tvpersonal" />

          <IconButton onClick={handleMenu} color="inherit">
            <AccountCircle style={{ color: '#f76d31' }} />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            open={isOpen}
            onClose={handleCloseMenu}
            onClick={handleCloseMenu}
          >
            <MenuItem onClick={handleProfile}>Meu perfil</MenuItem>
            <MenuItem onClick={handleTrainingRoutinesHistory}>
              Histórico
            </MenuItem>
            <MenuItem onClick={handleSignout}>Sair</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default NavBar;
